import * as React from "react";
import { bindActions, mockTheme } from "../utils/utils";
import { ComponentClass } from "react";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { getApi } from "../api/ApiProvider";
import { DriverActions, IDriverStore } from "../store/driver";
import { ISubmitEvent, UiSchema } from "react-jsonschema-form";
import { IStore } from "../store";
import { Driver, User, Vehicle } from "../api/model";
import { connect } from "react-redux";
import { JSONSchema6 } from "json-schema";

// components
import { RowDefinition } from "../components/schemaform/layout-renderer";
import SearchBox from "../components/SearchBox";
import { BranchData } from "src/components/BranchSelector";
import AsyncTable, { ColumnDefinition } from "../components/AsyncTable";
import EnhancedSchemaForm from "../components/schemaForm";

// material
import { Theme, WithStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { SortDirection } from "@material-ui/core/TableCell";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityOnIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/ModeEdit";
import BikeIcon from "@material-ui/icons/DirectionsBike";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import blue from "@material-ui/core/colors/blue";
import red from "@material-ui/core/colors/red";
import green from "@material-ui/core/colors/green";

const styles = (theme: Theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: `calc(50% - ${theme.spacing.unit * 3}px)`,
  },
  menu: {
    width: 200,
  },

  routeSelector: {
    width: "100%",
    height: "100%",
  },
  buttons: {
    marginLeft: "auto",
  },
  abm: {
    padding: theme.spacing.unit * 3,
    margin: theme.spacing.unit,
  },
  editIcon: {
    color: blue[500],
  },
  trackIcon: {
    color: red[500],
  },
  enableIcon: {
    color: green[900],
  },
  disableIcon: {
    color: red[900],
  },
  actionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  },
});

/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

interface DriversProps extends WithStyles<keyof typeof classesType> {
  actions: DriverActions;
  data: IDriverStore;
}

interface DriversState {
  abm: {
    open: boolean;
    data: {
      user: Partial<User>;
      driver: Partial<Driver>;
      vehicle: Partial<Vehicle>;
    };
  };
  table: {
    data: any;
    sortBy: string;
    sortDirection: SortDirection;
    columnData: ColumnDefinition[];
  };
  schema: any;
  allBranch: any;
  searchText: string;
}

const schema: JSONSchema6 = {
  title: "Chofer",
  type: "object",
  properties: {
    user: {
      type: "object",
      title: "Datos del usuario",
      required: ["name", "email", "password"],
      properties: {
        name: { type: "string", title: "Nombre" },
        email: { type: "string", title: "Correo electrónico", format: "email" },
        password: { type: "string", title: "Contraseña", minLength: 6 },
      },
    },
    driver: {
      type: "object",
      title: "Datos del conductor",
      required: ["region", "registryNumber", "registryDate", "type"],
      properties: {
        region: { type: "string", title: "Región preferida" },
        registryNumber: { type: "string", title: "Numero de registro" },
        registryDate: {
          type: "string",
          title: "Fecha emisión registro",
          format: "date",
        },
        phone: { type: "string", title: "Teléfono" },
        document: { type: "string", title: "Cédula de identidad o documento " },
        type: {
          type: "string",
          title: "Tipo de orden preferida",
          anyOf: [{ type: "string", enum: ["DELIVERY"], title: "Delivery" }],
          default: "DELIVERY",
        },
      },
    },
    vehicle: {
      type: "object",
      title: "Datos del vehículo",
      required: ["brand", "type"],
      properties: {
        brand: { type: "string", title: "Marca" },
        model: { type: "string", title: "Modelo" },
        type: {
          type: "string",
          title: "Tipo de vehículo",
          anyOf: [
            { type: "string", enum: ["MOTORCYCLE"], title: "Motocicleta" },
          ],
          default: "MOTORCYCLE",
        },
        year: { type: "string", title: "Año" },
      },
    },
    branch: {
      type: "number",
      title: "Sucursal",
      anyOf: [{ type: "number", enum: [0], title: "Cargando" }],
      default: 0,
    },
  },
};

const uiSchema: UiSchema = {
  user: {
    password: {
      "ui:widget": "password",
      "ui:help": "Usa un password complejo",
    },
    "ui:layout": [
      {
        name: { xs: 6 },
        email: { xs: 6 },
        password: { xs: 6, doShow: (value: any) => !value.id },
      },
    ] as RowDefinition[],
  },
  driver: {
    "ui:layout": [
      {
        document: { xs: 6 },
        phone: { xs: 6 },
        region: { xs: 6 },
        registryNumber: { xs: 6 },
        registryDate: { xs: 6 },
        type: { xs: 6 },
      },
    ],
  },
  vehicle: {
    "ui:layout": [
      { brand: { xs: 6 }, model: { xs: 6 }, type: { xs: 6 }, year: { xs: 6 } },
    ],
  },
  branch: { xs: 6 },
};

class Drivers extends React.Component<DriversProps, DriversState> {
  static getDefaultEntity() {
    return { driver: {}, vehicle: {}, user: {} };
  }

  constructor(props: DriversProps) {
    super(props);

    this.state = {
      abm: {
        open: false,
        data: Drivers.getDefaultEntity(),
      },
      searchText: "",
      table: {
        data: [],
        sortBy: "name",
        sortDirection: "desc",
        columnData: [
          { path: "document", numeric: false, label: "CI" },
          { path: "user.name", numeric: false, label: "Nombre" },
          { path: "user.email", numeric: false, label: "Correo" },
          {
            path: "user.state",
            numeric: false,
            label: "Estado",
            disablePadding: false,
          },
          {
            path: "branch.name",
            numeric: false,
            label: "Sucursal",
            disablePadding: false,
          },
          { path: "region", numeric: true, label: "Region" },
          {
            path: "",
            numeric: true,
            label: "Acciones",
            draw: (cd: ColumnDefinition, data: Driver) => {
              return (
                <div style={{ minWidth: 150 }}>
                  <IconButton
                    className={
                      data.user.state === "ACTIVE"
                        ? this.props.classes.enableIcon
                        : this.props.classes.disableIcon
                    }
                    onClick={
                      data.user.state === "ACTIVE"
                        ? this.handleDisable(data)
                        : this.handleActivate(data)
                    }
                  >
                    {data.user.state === "ACTIVE" ? (
                      <Tooltip title="Activo">
                        <VisibilityOnIcon />
                      </Tooltip>
                    ) : (
                      <Tooltip title="Inactivo">
                        <VisibilityOffIcon />
                      </Tooltip>
                    )}
                  </IconButton>

                  <IconButton
                    className={this.props.classes.editIcon}
                    aria-label="Editar"
                    onClick={this.edit(data)}
                  >
                    <Tooltip title="Editar">
                      <EditIcon />
                    </Tooltip>
                  </IconButton>
                  <Link to={"/driver/" + data.id}>
                    <IconButton
                      className={this.props.classes.trackIcon}
                      aria-label="Ver ubicación"
                      disabled={data.user.state === "INACTIVE"}
                    >
                      <Tooltip title="Ver ubicación">
                        <BikeIcon />
                      </Tooltip>
                    </IconButton>
                  </Link>
                </div>
              );
            },
          },
        ],
      },
      schema: schema,
      allBranch: [],
    };

    this.fillBranchInSchema(false, 0);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.showDialog = this.showDialog.bind(this);
    this.hideDialog = this.hideDialog.bind(this);
    this.handleDisable = this.handleDisable.bind(this);
  }

  handleDisable(data: any) {
    return (event: React.MouseEvent<HTMLElement>) => {
      this.props.actions.disable(data);
    };
  }
  handleActivate(data: any) {
    return (event: React.MouseEvent<HTMLElement>) => {
      this.props.actions.activate(data);
    };
  }

  setRequired(isEdit: boolean) {
    if (schema.properties) {
      const user = schema.properties.user as JSONSchema6;

      if (isEdit) {
        user.required = ["name", "email"];
      } else {
        user.required = ["name", "email", "password"];
      }
    }
  }

  fillBranchInSchema(isEdit: boolean, id: number) {
    getApi()
      .branch()
      .listAllBranchesAdmin()
      .then((data: BranchData[]) => {
        this.setState({ allBranch: data });

        const newSchema: JSONSchema6 = JSON.parse(JSON.stringify(schema));
        const branch = newSchema.properties!.branch as JSONSchema6;

        if (isEdit) {
          branch.default = id;
        }
        branch.anyOf = data.map((d) => {
          return {
            type: "number",
            enum: [d.id],
            title: d.name || "",
          } as JSONSchema6;
        });

        this.setState({ schema: newSchema });
      });
  }

  edit(data: Driver) {
    return (event: React.MouseEvent<HTMLElement>) => {
      this.setRequired(true);
      this.fillBranchInSchema(true, data.branch.id);
      this.setState({
        abm: {
          open: true,
          data: {
            user: data.user,
            driver: {
              ...data,
              registryDate: format(data.registryDate, "YYYY-MM-DD"),
            },
            vehicle: {
              ...data.vehicle,
              year: data.vehicle.year,
              type: data.vehicle.type,
            },
          },
        },
        schema: schema,
      });
    };
  }

  filterBranch(branch: number) {
    const dataBranchs = this.state.allBranch;
    return dataBranchs.filter((d: any) => d.id === branch);
  }

  handleSubmit(e: ISubmitEvent<any>) {
    const dataDriver = {
      branch: e.formData.branch,
      ...e.formData,
    };

    const filterBranch = this.filterBranch(dataDriver.branch);
    dataDriver.driver.branch = filterBranch[0];

    dataDriver.driverPassw = e.formData.user.password
      ? e.formData.user.password
      : "";

    if (e.formData.driver.id) {
      delete dataDriver.user.password;
    }

    this.props.actions.save({
      ...dataDriver,
    });
    this.hideDialog();
  }

  sort(name: string) {
    return () => {
      this.setState({
        ...this.state,
        table: {
          ...this.state.table,
          sortBy: name,
          sortDirection: "desc",
        },
      });
    };
  }

  componentDidMount() {
    this.props.actions.fetch();
  }

  hideDialog() {
    this.setState({
      abm: { ...this.state.abm, open: false },
    });
  }

  showDialog() {
    this.setRequired(false);
    this.setState({
      abm: { data: Drivers.getDefaultEntity(), open: true },
    });
  }

  filter(search: any) {
    const s = search == null ? this.state.searchText : search;
    this.props.actions.filter(s);
  }

  render() {
    return (
      <>
        <Grid item sm={12} md={12}>
          <div className={this.props.classes.actionHeader}>
            <SearchBox
              placeHolder="Ingrese CI y presione ENTER"
              doSearch={(search) => {
                this.setState({ searchText: search });
                this.filter(search);
              }}
              hasFilter={false}
            />
          </div>
        </Grid>
        <Grid container spacing={24}>
          <Grid item sm={12} md={12}>
            <AsyncTable
              columnDefinition={this.state.table.columnData}
              title="Choferes"
              data={this.props.data.data}
              defaultOrder={{
                name: "name",
                direction: "desc",
              }}
              headerButtons={
                <Tooltip title="Agregar chofer">
                  <IconButton
                    aria-label="Agregar chofer"
                    onClick={this.showDialog}
                  >
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              }
            />
          </Grid>
          <Dialog open={this.state.abm.open} maxWidth="md" fullWidth={true}>
            <Paper className={this.props.classes.abm}>
              <EnhancedSchemaForm
                schema={this.state.schema}
                formData={this.state.abm.data}
                uiSchema={uiSchema}
                onSubmit={this.handleSubmit}
              >
                <div>
                  <Button variant="contained" onClick={this.hideDialog}>
                    Cancelar
                  </Button>
                  &nbsp;
                  <Button variant="contained" color="primary" type="submit">
                    Aceptar
                  </Button>
                </div>
              </EnhancedSchemaForm>
            </Paper>
          </Dialog>
        </Grid>
      </>
    );
  }
}

const mapStateToProps = (state: IStore, ownProps: DriversProps) => ({
  ...ownProps,
  data: state.driver,
});

const styled = withStyles(styles as any)(Drivers);
const connected = connect(mapStateToProps, bindActions(DriverActions))(styled);

export default connected as ComponentClass<Partial<DriversProps>>;



// WEBPACK FOOTER //
// ./src/pages/DriverListPage.tsx